export const searchTypesArray = ['popups', 'events'] as const;

export type SearchType = typeof searchTypesArray[number];

export type SearchType2 = 'popups' | 'events';
